import { baseEnvironment } from '../environment.base';
import { clientEnvironment } from '../../client/environment.client.prod';

export const environment = {
  ...baseEnvironment,
  production: true,
  ...clientEnvironment,
};

// regex that matches http://localhost:9400/app and https://www.clubity.com/app and https://stage1.clubity.com/app/ and https://stage14.clubity.com/app/
